import { useEffect, useState } from "react";
import { Tabs, Button } from "antd";
import { useNavigate } from "react-router";
import { Building2, Users, UserCheck, ArrowLeft } from "lucide-react";

import Layout from "../layout/Layout";
import CompanyLeft from "../components/company-search/CompanyLeft";
import CompanyContent from "../components/company-search/CompanyContent";
import CompanyNavigation from "../components/company-search/CompanyNavigation";

import ExecutiveLeft from "../components/executive-search/ExecutiveLeft";
import ExecutiveContent from "../components/executive-search/ExecutiveContent";
import ExecutiveNavigation from "../components/executive-search/ExecutiveNavigation";
import CalenderModal from "../components/lead-search/CalenderModal";

const LeadsTimeline = ({ tab }) => {
  const [activeTab, setActiveTab] = useState(tab || "1");
  const navigate = useNavigate();

  useEffect(() => {
    if (tab) {
      setActiveTab(tab);
    }
  }, [tab]);

  const onChange = (key) => {
    setActiveTab(key);
  };

  const goToLeadsPage = () => {
    navigate("/search-lead");
  };

  const items = [
    {
      key: "1",
      label: (
        <span className="tw-flex tw-items-center tw-gap-2 tw-font-inter tw-font-medium">
          <Building2 size={16} className="tw-text-slate-500" />
          <span>Companies</span>
        </span>
      ),
      children: (
        <div>
          <CompanyNavigation />
          <div id="wrapper" className="tw-flex tw-gap-4 tw-mt-4">
            <div className="leftmenu">
              <CompanyLeft />
            </div>
            <div className="contentbody shadow tw-rounded-2xl tw-bg-white tw-border tw-border-solid tw-border-slate-200/80">
              <CompanyContent />
            </div>
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <span className="tw-flex tw-items-center tw-gap-2 tw-font-inter tw-font-medium">
          <Users size={16} className="tw-text-slate-500" />
          <span>Executive</span>
        </span>
      ),
      children: (
        <div>
          <ExecutiveNavigation />
          <div id="wrapper" className="tw-flex tw-gap-4 tw-mt-4">
            <div className="leftmenu">
              <ExecutiveLeft />
            </div>
            <div className="contentbody shadow tw-rounded-2xl tw-bg-white tw-border tw-border-solid tw-border-slate-200/80">
              <ExecutiveContent />
            </div>
          </div>
        </div>
      ),
    },
    {
      key: "3",
      label: (
        <span className="tw-flex tw-items-center tw-gap-2 tw-font-inter tw-font-medium">
          <UserCheck size={16} className="tw-text-slate-500" />
          <span>Leads</span>
        </span>
      ),
      children: (
        <div>
          <div className="tw-mb-4 tw-flex tw-items-center tw-justify-between tw-bg-white tw-p-4 tw-rounded-2xl tw-border tw-border-solid tw-border-slate-200/80 tw-shadow-sm">
            <Button
              type="primary"
              onClick={goToLeadsPage}
              className="!tw-bg-theme hover:!tw-bg-theme/90 !tw-border-theme tw-text-white tw-text-xs tw-font-bold tw-h-9 tw-rounded-xl tw-px-4 tw-flex tw-items-center tw-gap-2"
            >
              <ArrowLeft size={16} />
              <span>Back to Lead Search</span>
            </Button>
          </div>

          <div id="wrapper" className="tw-bg-white tw-p-4 tw-rounded-2xl tw-border tw-border-solid tw-border-slate-200/80 tw-shadow-sm">
            <CalenderModal />
          </div>
        </div>
      ),
    },
  ];

  return (
    <Layout>
      <div className="tw-font-inter tw-p-2">
        <h3 className="tw-text-xl tw-font-bold tw-text-slate-800 tw-mb-4 tw-font-inter">
          {activeTab === "1"
            ? "Search Companies"
            : activeTab === "2"
              ? "Search Executive"
              : "Leads Timeline Activities"}
        </h3>
        <Tabs
          activeKey={activeTab}
          items={items}
          onChange={onChange}
          type="card"
          className="tw-font-inter"
        />
      </div>
    </Layout>
  );
};

export default LeadsTimeline;
